import api from "./api";

class OdaManager {

    ordiniVendita(sottoprogetto_id: number | string, fornitore_id: number | string, params: any = {}) {
        return api.get(`sottoprogetti/${sottoprogetto_id}/fornitori/${fornitore_id}/oda`, {params})
    }

    dettaglioOdaGamma(ditta: number | string, n_reg: number | string) {
        return api.get(`oda/${ditta}/${n_reg}/`)
    }

    righeOdaGamma(ditta: number | string, n_reg: number | string, params = {}) {
        return api.get(`oda/${ditta}/${n_reg}/righe`, {params})
    }
}

const odaManager = new OdaManager()

export default odaManager
